// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLeft_root__tsr5V"};